import { Workspace } from 'types'

/**
 * Provide the origin for paths in the frontend.
 * @returns https://almanac.io | https://subdomain.almanac.io | https://completelycustomdomain.com
 */
export function frontendOrigin(ws?: Workspace) {
  // This happens to do the same as src/utils/location.ts:getOrigin() but the intention is different
  // eslint-disable-next-line no-restricted-properties
  return window.location.origin
}

/**
 * Provide the hostname (no port info) for paths in the frontend.
 * @returns almanac.io | subdomain.almanac.io | completelycustomdomain.com
 */
export function frontendHostname(ws?: Workspace) {
  // eslint-disable-next-line no-restricted-properties
  return window.location.hostname
}
